import QrCodePendingContent from './Pending';
import { PixProps } from './props';
import TransactionResult from '../../../../../../Result';
import { DepositStatusId } from '@starsoft/common/models/deposit/status/id';

/**
 * QrCodeResponse Component
 * This component is responsible for rendering the appropriate content based on the deposit status.
 * It conditionally renders either a QR code pending content or a transaction result based on the deposit status.
 *
 * @param {PixProps} props - The properties for the component.
 * @param {object} props.deposit - The deposit object containing the status and other details.
 *
 * @returns {JSX.Element} The rendered component based on the deposit status.
 *
 * @example
 * // Usage example:
 * const deposit = { status: { id: '1' }, ...otherProps };
 * <QrCodeResponse deposit={deposit} />
 */
export default function QrCodeResponse({ deposit }: PixProps) {
  switch (deposit?.status?.id?.toString()) {
    case DepositStatusId.Pending?.toString():
    case DepositStatusId.Created?.toString():
      // Render the QR code pending content if the deposit status is 'Pending' or 'Created'
      return <QrCodePendingContent deposit={deposit} />;
    default:
      // Render the transaction result for any other deposit status
      return <TransactionResult transaction={deposit} />;
  }
}
